/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'gemini/lib/@waca/dashboard-common/dist/core/APIFactory',
	'./SmartColorMapAPI'
], function( APIFactory, SmartColorMapAPI) {


	class SmartColorMapFeatureProvider {

		constructor({ features }) {
			if(features) {
				this.ajaxSvc = features['API'].getGlassCoreSvc('.Ajax');
				this.fredIsRed = features.FredIsRed;
				this.internalAPI = features.internal;
				this.smpColorMap = features.SMPColorMap;

				//maps to ensure color map initialization is done only once per datasource-source
				//as setupColorMap could get called from multiple LW on the same datasource-source
				this.colorMapPromise = {}; // tracks final colormap per datasource
				this.smartModulePromise  = {}; //tracks fetching smart module per datasource
				this.ds2ColorMap = {}; //tracks color map setup/initialization per datasource
			}
		}

		getAPI() {
			if (!this._api) {
				this._api = APIFactory.createAPI(this, [SmartColorMapAPI]);
			}
			return this._api;
		}

		_ensureFredIsRedFeatureInitialized() {
			const boardModel = this.internalAPI.getBoardModel();
			const fredIsRed = boardModel.get('fredIsRed');
			this.fredIsRed.initializeFredIsRedFeature(fredIsRed);
		}

		setupColorMap(datasourceId, datasourceType/*, columnList*/){
			this._ensureFredIsRedFeatureInitialized();

			//call smarts to get smarts module & setup color map if needed
			if( this.colorMapPromise[datasourceId] ) {
				return Promise.resolve(this.colorMapPromise[datasourceId]);
			} else {
				this.colorMapPromise[datasourceId] = this._fetchSmartModule(datasourceId)
					.then( this._setColorMap.bind(this, datasourceId, datasourceType) );
				return this.colorMapPromise[datasourceId];
			}
		}



		_fetchSmartModule(datasourceId) {
			this.smartModulePromise[datasourceId] = Promise.resolve(true); //bypass smarts for now
			if( this.smartModulePromise[datasourceId] ) {
				return this.smartModulePromise[datasourceId];
			}
			const url = `v1/smarts/module/${datasourceId}?conceptsOnly`;
			this.smartModulePromise[datasourceId] = new Promise((resolve, reject) => {
				this.ajaxSvc.ajax({
					type: 'get',
					url: url,
					contentType: 'application/json'
				}).then((data) => {
					resolve(data);
				}, (err) => {
					reject(err);
				});
			});
			return this.smartModulePromise[datasourceId];
		}

		_setColorMap(datasourceId, datasourceType, concepts) {
			if( this.ds2ColorMap[datasourceId]) {
				return Promise.resolve(this.ds2ColorMap[datasourceId]);
			} else {
				//invoke fred is red api, set color map
				//TODO
				if( this.smpColorMap.hasApplicableColorMap(datasourceType,concepts) ){
					this.fredIsRed.registerKeyProvider(this.smpColorMap);
					this.ds2ColorMap[datasourceId] = this.smpColorMap.getUserColorMap();
					return this.fredIsRed.setUserColorMap(this.ds2ColorMap[datasourceId]);
				}
				return Promise.resolve(true);
			}

		}
	}

	return SmartColorMapFeatureProvider;

});
